<template>
  <div class="accreditation-container">
    <JotForm :src="url" :initial-height="1100" />
  </div>
</template>

<script>
import JotForm from '@/components/common/JotForm.vue';

export default {
  components: {
    JotForm,
  },
  computed: {
    url() {
      return process.env.VUE_APP_CUSTOM_THEME_JOTFORMS_ACCREDITATION_URL ?? '';
    },
  },
};
</script>

<style lang="scss" scoped>
.accreditation-container {
  width: 100%;
}
</style>
